import {
  UPDATE_NOTIFICATION_ALERTS,
  RESET_NOTIFICATION_ALERTS
} from "./actionTypes"

export const update_notification_alerts = alert => {
  return {
    type: UPDATE_NOTIFICATION_ALERTS,
    payload: alert,
  }
}

export const reset_notification_alerts = () => {
  return {
    type: RESET_NOTIFICATION_ALERTS,
  }
}
